import { useTranslation } from 'react-i18next'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { FeedbackStatus } from '@/types/feedback'

const POSITION: Record<FeedbackStatus, number> = {
  received: 0,
  in_progress: 1,
  resolved: 2,
  not_planned: 2,
}

export function FeedbackTimeline({ status }: { status: FeedbackStatus }) {
  const { t } = useTranslation('feedback')
  const current = POSITION[status]
  const outcome: FeedbackStatus = status === 'not_planned' ? 'not_planned' : 'resolved'
  const steps: FeedbackStatus[] = ['received', 'in_progress', outcome]

  return (
    <ol aria-label={t('detail.timeline')} className="flex flex-wrap items-center gap-2 text-sm">
      {steps.map((step, index) => (
        <li
          key={step}
          aria-current={index === current ? 'step' : undefined}
          className={cn(
            'flex items-center gap-2',
            index > current && 'text-muted-foreground',
            index === current && 'font-medium',
          )}
        >
          <span
            className={cn(
              'flex h-6 w-6 items-center justify-center rounded-full border text-xs',
              index <= current && 'border-primary bg-primary text-primary-foreground',
            )}
          >
            {index < current ? <Check className="h-3 w-3" /> : index + 1}
          </span>
          <span>{t(`statuses.${step}`)}</span>
          {index < steps.length - 1 && <span className="mx-1 h-px w-6 bg-border" />}
        </li>
      ))}
    </ol>
  )
}
